import React, { useEffect } from "react";

/* ============================================================
   STATS — updated to mirror the Hero section's stats exactly
   (3000+ Happy Clients, 100+ Products Delivered, 8+ Years
   Experience, 20+ Industry Awards), including the same icons
   and purple brand accent (#6a1fd0 / #6c0a9f) used in Hero.jsx,
   instead of the old placeholder set (Placements, Courses,
   Services, Years Experience).
============================================================ */

const STATS_DATA = [
  {
    value: 3000,
    suffix: "+",
    label: "Happy Clients",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  {
    value: 100,
    suffix: "+",
    label: "Products Delivered",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 16.5c0 .38-.21.71-.53.88l-7.9 4.44c-.16.12-.36.18-.57.18s-.41-.06-.57-.18l-7.9-4.44A.991.991 0 0 1 3 16.5v-9c0-.38.21-.71.53-.88l7.9-4.44c.16-.12.36-.18.57-.18s.41.06.57.18l7.9 4.44c.32.17.53.5.53.88v9z"
          stroke="currentColor"
          strokeWidth="1.6"
          fill="none"
        />
        <path d="M3.27 6.96 12 12.01l8.73-5.05M12 22.08V12" stroke="currentColor" strokeWidth="1.6" fill="none" />
      </svg>
    ),
  },
  {
    value: 8,
    suffix: "+",
    label: "Years Experience",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2l2.9 6.26L21 9.27l-4.5 4.38L17.8 21 12 17.77 6.2 21l1.3-7.35L3 9.27l6.1-1.01L12 2z" fill="currentColor" />
      </svg>
    ),
  },
  {
    value: 20,
    suffix: "+",
    label: "Industry Awards",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 15.5c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zM8.21 13.89 7 22l5-3 5 3-1.21-8.12"
          stroke="currentColor"
          strokeWidth="1.6"
          fill="none"
        />
      </svg>
    ),
  },
];

const STATS = () => {
  useEffect(() => {
    const counters = document.querySelectorAll(".timer");
    counters.forEach((counter) => {
      const target = +counter.getAttribute("data-to");
      const speed = +counter.getAttribute("data-speed") || 4000;
      let count = 0;
      const increment = Math.ceil(target / (speed / 20));
      const updateCount = () => {
        count += increment;
        if (count >= target) {
          counter.innerText = target;
        } else {
          counter.innerText = count;
          setTimeout(updateCount, 20);
        }
      };
      updateCount();
    });
  }, []);

  return (
    <>
      <section className="stats-section pt80 pb80 bg-stats fade-in-up">
        <div className="container">
          <div className="row text-center">
            {STATS_DATA.map((item, i) => (
              <div key={i} className="col-lg-3 col-md-6 mb30 fade-in-up">
                <div className="stat-card modern-card hover-lift">
                  <div className="stat-card-icon">{item.icon}</div>
                  <h2 className="timer" data-to={item.value} data-speed={3000}>
                    0
                  </h2>
                  <span>
                    {item.suffix} {item.label}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* CSS */}
      <style>{`
        .bg-stats {
          background: #f4f6fb;
        }
        .stat-card {
          background: #fff;
          border-radius: 16px;
          padding: 35px 20px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
        }
        .stat-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 45px rgba(106, 31, 208, 0.18);
        }
        .stat-card-icon {
          width: 34px;
          height: 34px;
          margin: 0 auto 14px;
          color: #6a1fd0;
        }
        .stat-card-icon svg {
          width: 100%;
          height: 100%;
        }
        /* NUMBER */
        .stat-card h2 {
          font-size: 44px;
          font-weight: 700;
          color: #14142b;
          margin-bottom: 6px;
        }
        /* TEXT */
        .stat-card span {
          font-size: 16px;
          font-weight: 500;
          color: #6c0a9f;
        }
      `}</style>
    </>
  );
};

export default STATS;